/**
 * Fire-and-forget image preloader.
 *
 * Runs during the ~750ms splash so the very first paint after the splash
 * has the login photo, recipe fallback etc. already in the browser cache.
 * No error handling — if a preload fails it just means the image loads
 * normally later.
 */
const CRITICAL_IMAGES = [
  // Login page hero
  "https://images.unsplash.com/photo-1540420773420-3366772f4999?crop=entropy&cs=srgb&fm=jpg&w=1400&q=80",
  // Recipe list fallback + empty state
  "https://images.pexels.com/photos/842545/pexels-photo-842545.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  "https://images.unsplash.com/photo-1490818387583-1baba5e638af?crop=entropy&cs=srgb&fm=jpg&w=900&q=80",
  // App logo (splash + PWA icon)
  "/logo.png",
];

export function preloadCriticalImages() {
  for (const src of CRITICAL_IMAGES) {
    const img = new Image();
    img.decoding = "async";
    img.loading = "eager";
    img.src = src;
  }
}
